function CloseSquareOutlined() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			fill="none"
			viewBox="0 0 20 20"
		>
			<path fill="#fff" stroke="#C6C6C6" d="M.5.5h19v19H.5z"></path>
			<path
				stroke="#444"
				strokeWidth="1.5"
				d="m5.977 5.969 8.054 8.054M14.031 5.969l-8.054 8.054"
			></path>
		</svg>
	);
}

export default CloseSquareOutlined;
